import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Button from 'atoms/Button/Button';
import Dropdown from 'atoms/Dropdown/Dropdown';
import Input from 'atoms/Input/Input';
import useDebounceCallback from 'hooks/useDebounceCallback';
import FilePlusSvg from 'images/v5/icons/file-plus-01.svg';
import FolderPlusSvg from 'images/v5/icons/folder-plus.svg';
import PlusSvg from 'images/v5/icons/plus.svg';
import LoopSvg from 'images/v5/icons/search-md.svg';
import { openModal } from 'store/layoutSlice';
import { addSpecification, selectSpecificationDetailsStatus, } from 'store/specificationDetailsSlice';
import { fetchRootFolder, fetchRootFolders, resetFilters as resetFoldersFilters, selectRootFolder, setFilter as setFoldersFilter, } from 'store/specificationsFoldersSlice';
import { resetFilters as resetSpecificationsFilters, setFilter as setSpecificationsFilter, } from 'store/specificationsSlice';
function HeaderAside({ folders = false, warehouseReleaseSelect, }) {
    const { t } = useTranslation(['specification', 'exceptions', 'common']);
    const dispatch = useDispatch();
    const location = useLocation();
    const rootFolder = useSelector(selectRootFolder);
    const folderId = location.pathname.includes('/specifications/folders/')
        ? location.pathname.replace('/specifications/folders/', '')
        : rootFolder === null || rootFolder === void 0 ? void 0 : rootFolder.rootFolderId;
    const debouncedSpecificationsSearch = useDebounceCallback((searchQuery) => {
        dispatch(setSpecificationsFilter({ filterName: 'search', value: searchQuery }));
    }, 1000);
    const debouncedFoldersSearch = useDebounceCallback((searchQuery) => {
        dispatch(setFoldersFilter({ filterName: 'search', value: searchQuery }));
    }, 1000);
    const addingStatus = useSelector(selectSpecificationDetailsStatus).add;
    useEffect(() => {
        return () => {
            if (folders) {
                dispatch(resetFoldersFilters());
            }
            else {
                dispatch(resetSpecificationsFilters());
            }
        };
    }, [dispatch, folders]);
    const handleSearchFilter = (e) => {
        const newQuery = e.target.value;
        if (folders) {
            debouncedFoldersSearch(newQuery);
        }
        else {
            debouncedSpecificationsSearch(newQuery);
        }
    };
    useEffect(() => {
        dispatch(fetchRootFolder());
    }, [dispatch]);
    useEffect(() => {
        if (rootFolder.rootFolderId !== null) {
            dispatch(fetchRootFolders({ folderId: rootFolder.rootFolderId }));
        }
    }, [dispatch, rootFolder.status, rootFolder.rootFolderId]);
    const handleFolderCreatorOpen = () => {
        dispatch(openModal({ name: 'folderCreator' }));
    };
    const handleSpecificationCreatorOpen = () => {
        dispatch(addSpecification({ folderId })).then((response) => {
            var _a, _b;
            return ((_a = response.payload) === null || _a === void 0 ? void 0 : _a.id) &&
                dispatch(openModal({ name: 'specificationCreator', data: { id: (_b = response.payload) === null || _b === void 0 ? void 0 : _b.id } }));
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, { size: "s", leftIcon: React.createElement(LoopSvg, null), placeholder: t('common:search'), onChange: (e) => handleSearchFilter(e) }),
        !warehouseReleaseSelect && (React.createElement(Dropdown, { position: "bottomRight", trigger: React.createElement(Button, { leftIcon: React.createElement(PlusSvg, null), onClick: () => { }, loading: addingStatus === 'loading' }, t('create')) },
            React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(FolderPlusSvg, null), onClick: handleFolderCreatorOpen }, t('folder')),
            React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(FilePlusSvg, null), onClick: handleSpecificationCreatorOpen }, t('specification_capitalize'))))));
}
export default HeaderAside;
